module.exports = __webpack_public_path__ + "img/4_45.213ef3d8.png";